<template>
  <thead class="[&>tr]:bg-primary-50">
    <slot />
  </thead>
</template>
